import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=574cad58&scoped=true"
import script from "./productInfo.vue?vue&type=script&lang=js"
export * from "./productInfo.vue?vue&type=script&lang=js"
import style0 from "./productInfo.vue?vue&type=style&index=0&id=574cad58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574cad58",
  null
  
)

export default component.exports